/**
 * Determines which locales are invalid
 *
 * @param {{[key: string]: any}} errors
 * @param {string} defaultLocale
 * @param {string[]} locales
 * @param {string[]} [invalidLocales = []]
 * @returns {string[]}
 */
export default function getInvalidLocales(
  errors = {},
  defaultLocale,
  locales,
  invalidLocales = [],
) {
  Object.keys(errors).forEach((key) => {
    if (typeof errors[key] === "object") {
      if (Object.keys(errors[key]).some((k) => ["message"].includes(k))) {
        if (locales.includes(key) && !invalidLocales.includes(key)) {
          invalidLocales.push(key);
        } else if (!invalidLocales.includes(defaultLocale)) {
          invalidLocales.push(defaultLocale);
        }
      } else {
        getInvalidLocales(errors[key], defaultLocale, locales, invalidLocales);
      }
    }
  });

  return invalidLocales;
}
